import { render } from "./socialMedia.vue?vue&type=template&id=02aa859c&scoped=true"
import script from "./socialMedia.vue?vue&type=script&lang=js"
export * from "./socialMedia.vue?vue&type=script&lang=js"

import "./socialMedia.vue?vue&type=style&index=0&id=02aa859c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02aa859c"]])

export default __exports__